module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Apocalypse-Now.2c4aa01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Apocalypse-Now.jpg
// module id = 73pS
// module chunks = 0